module.exports = __webpack_public_path__ + "static/media/Menu-5.a2af34f9.jpg";